import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    publicKey: String,
  }

  async connect() {
    this.stripe = Stripe(this.publicKeyValue)
    this.checkout = await this.stripe.createEmbeddedCheckoutPage({clientSecret: await this.fetchClientSecret()});
    this.checkout.mount(this.element)
  }

  disconnect() {
    this.checkout.destroy()
  }

  async fetchClientSecret() {
    const csrfToken = document.querySelector("[name='csrf-token']").content;
    const response = await fetch("/submissions/checkout", {
      method: "POST",
      headers: {
        "X-CSRF-Token": csrfToken,
        "Content-Type": "application/json",
      }
    });
    const { clientSecret } = await response.json();
    return clientSecret;
  }
}